"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTag = exports.AditionalInfo = exports.Subtitle = exports.Title = exports.InfoContainer = exports.Image = exports.CustomLink = exports.ImageContainer = exports.Container = void 0;
const tslib_1 = require("tslib");
const react_router_dom_1 = require("react-router-dom");
const Tag_1 = (0, tslib_1.__importDefault)(require("../../atoms/Tag"));
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Container = styled_components_1.default.div `
  min-width: 340px;
  grid-template-rows: min-content;
  position: relative;
  
  @media (min-width: 1440px) {
    min-width: 359px;
  }
  @media (min-width: 1920px) {
    min-width: 318px;
  }
`;
exports.ImageContainer = styled_components_1.default.div `
  min-height: 280px;
  background: ${theme_1.colors.lighterGrey};
  display: grid;
  grid-template-areas: '. . .';
  grid-template-columns: 0.25fr 1fr 0.25fr;
  align-items: center;
`;
exports.CustomLink = (0, styled_components_1.default)(react_router_dom_1.Link) `
  grid-column: 2;
`;
exports.Image = styled_components_1.default.img `
  grid-column: 2;
  height: 100%;
  width: 100%;
  cursor: pointer;
  position: relative;
  object-fit: contain;
  aspect-ratio: 1 / 1;
`;
exports.InfoContainer = styled_components_1.default.div `
  min-height: 104px;
  background: ${theme_1.colors.white};
  display: flex;
  flex-direction: column;
  padding: 16px;
  text-align: left;
  gap: 6px;
`;
exports.Title = styled_components_1.default.p `
  text-transform: none;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
`;
exports.Subtitle = styled_components_1.default.p `
  text-transform: none;
  font-size: 9pt;
`;
exports.AditionalInfo = styled_components_1.default.p `
  color: ${theme_1.colors.blue};
  font-size: 9pt;
`;
exports.CustomTag = (0, styled_components_1.default)(Tag_1.default) `
  position: absolute;
  margin: 16px;
  font-weight: 500;
  background: ${theme_1.colors.blue};
`;
